export const COMPANY = {
  name: "M NAIEF",
  full: "M NAIEF Brindes Personalizados",
  slogan: "Brindes Personalizados que Fortalecem Sua Marca",
  phoneDisplay: "(11) 97192-9601",
  phoneRaw: "5511971929601",
  phonesDisplay: ["(11) 97192-9601", "(11) 94755-7408"],
  phonesRaw: ["5511971929601", "5511947557408"],
  landlineDisplay: "(11) 4969-5002",
  landlineRaw: "551149695002",
  instagramHandle: "@marcelonaief",
  instagramUrl: "https://instagram.com/marcelonaief",
  address: "Av. Pedro de Souza Lopes, 320 — Vila Galvão, Guarulhos – SP, 07074-080",
  cep: "07074-080",
  city: "Guarulhos",
  state: "SP",
  email: "comercial@mnaief.com.br",
};

export const WHATSAPP_DEFAULT_MSG = encodeURIComponent(
  "Olá! Tenho interesse em solicitar um orçamento de brindes personalizados da M NAIEF."
);

export const whatsappLink = (msg) =>
  `https://wa.me/${COMPANY.phoneRaw}?text=${msg || WHATSAPP_DEFAULT_MSG}`;
